import { useLayoutEffect } from "react";
import * as React from "react";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { TransitionProps } from "@mui/material/transitions";
import BounakirMessage from "./../../pages/DoubleMatch/BounakirMessage";
import { useHistory, useLocation } from "react-router-dom";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BounakirModal = NiceModal.create(
  ({
    bounakirMessage,
    doubleMatchType,
    memberCode,
    memberName,
    memberImage,
    userName,
  }: any) => {
    const modal = useModal();
    const location = useLocation();
    const history = useHistory();
    const openModalHashStateId = `${location.pathname}${location.search}&popup=bounkirMessage`;

    useLayoutEffect(() => {
      const listen = history.listen(historyBack);
      if (modal.visible) {
        window.history.pushState(
          { openModalHashStateId },
          `${openModalHashStateId}`,
          `${openModalHashStateId}`
        );
      }
      return () => listen();
    }, [modal.visible]);

    const historyBack = () => {
      modal.hide();
    };

    const handleModalToggle = () => {
      history.goBack();
      modal.hide();
    };

    //TODO: For testings
    React.useEffect(() => {
      console.log({ openModalHashStateId });
    }, [openModalHashStateId]);

    return (
      <>
        <div>
          <Dialog
            fullScreen
            TransitionComponent={Transition}
            open={modal.visible}
            onClose={handleModalToggle}
          >
            <div
              className="bounakirMessage-container"
              style={{ overflowY: "auto" }}
            >
              <BounakirMessage
                {...{
                  doubleMatchType,
                  bounakirMessage,
                  memberName,
                  memberCode,
                  memberImage,
                  userName,
                }}
              />
            </div>
          </Dialog>
        </div>
      </>
    );
  }
);

export default BounakirModal;
